<template>
  <div class="wrapper">
    <div class="list-wrp">
      <van-tabs style="height: 100%" v-model="active" @click="onTabClick">
        <van-tab title="纸票">
          <Invoice v-if="active === 0"/>
        </van-tab>
        <van-tab title="电票">
          <EInvoice v-if="active === 1"/>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import Invoice from './Invoice'
import EInvoice from './EInvoice'
import { Tab, Tabs } from 'vant'
import { getQuery } from '@utils/basicUtil'
export default {
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    Invoice,
    EInvoice
  },
  props: {},
  data () {
    return {
      active: 0
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {
    this.initActive()
  },
  activated () {},
  updated () {},
  methods: {
    initActive () {
      let { active } = getQuery()
      if (active === '0' || active === '1') {
        this.active = Number(active)
      }
    },
    onTabClick (name) {
      this.$router.replace(`/message/unsend?active=${name}`)
    }
  }
}
</script>
<style lang="less" scoped src="./style.less"/>
